// @ts-nocheck
import { Suspense, useCallback } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'
import { useTranslation } from 'react-i18next'

interface MedicationRoundsFieldProps {
  fields: Record<string, any>
  formId: string
  formState: Record<string, any>
  setFormState: (key: string, value: any) => void
  readOnly?: boolean
  testId?: string
}

/**
 * @description Renders MedicationRoundsField for the Add Medication modal
 * @param {MedicationRoundsFieldProps} props - The component's props.
 * @returns {JSX.Element} MedicationRoundsField.
 */
export default function MedicationRoundsField(
  props: MedicationRoundsFieldProps
): JSX.Element {
  const { fields, formId, formState, setFormState, readOnly, testId } = props

  const { t } = useTranslation()

  const note = useCallback(
    () => (
      <div
        style={styles.titleGreyText}
        data-testid={
          testId ? `${testId}-medication-rounds-note` : 'medication-rounds-note'
        }
      >
        {t('MEDICATION_ROUNDS_AND_DOSE_NOTE')}
      </div>
    ),
    [t, testId]
  )

  return (
    <div
      style={readOnly ? styles.editContainer : styles.container}
      data-testid={
        testId ? `${testId}-medication-rounds-field` : 'medication-rounds-field'
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          fieldType="medicationRounds"
          formId={formId}
          formState={formState}
          // helpLink={'https://support.logmycare.co.uk/en/articles/4851788-how-do-i-set-up-my-care-service-s-medication-round-times'}
          label={t('MEDICATION_ROUNDS_AND_DOSE')}
          renderLabelChildren={note}
          setFormState={setFormState}
          readOnly={readOnly}
          formKey="emarRoundsDetails"
          type="userGeneratedFieldLayout"
          values={fields}
        />
      </Suspense>
    </div>
  )
}

const styles = {
  editContainer: {
    pointerEvents: 'none',
    opacity: 0.6,
    marginTop: 22
  },
  container: {
    marginTop: 22
  },
  title: {
    lineHeight: '22px'
  },
  titleGreyText: {
    color: colors.darkgrey,
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 11
  }
}
